// Table column configuration for the main inventory table.
// Each object defines a column's title and how to extract or format its value from a row object.
export const columnsInventory = [
  // Item name column, displays the name of the inventory item.
  { title: 'Item', data: 'itemName' },

  // Category column, shows the item's category (e.g., Food, Paper).
  { title: 'Category', data: 'category' },

  // Suggested Price column, formats the price as a dollar amount with two decimals.
  {
    title: 'Suggested Price',
    data: (row) => '$' + parseFloat(row.suggestedPrice).toFixed(2)
  },

  // Unit Qty column, displays the quantity per unit (e.g., 12 for a 12-pack).
  { title: 'Unit Qty', data: 'unitQty' },

  // Pack Size column, shows the pack size (e.g., 1pk, 6pk).
  { title: 'Pack Size', data: 'packSize' },

  // Quantity column, displays the quantity on hand (QOH) for the item.
  { title: 'Quantity', data: 'qoh' },

  // Value column, calculates and displays the total value of the item (price * quantity).
  {
    title: 'Value',
    data: (row) => {
      const price = parseFloat(row.suggestedPrice); // Convert suggested price to number
      const quantity = parseInt(row.qoh, 10); // Convert QOH to integer
      // If either value is not a number, show $0.00; otherwise, show calculated total
      const total = isNaN(price) || isNaN(quantity) ? 0 : price * quantity;
      return '$' + total.toFixed(2);
    }
  },
];

// Table column configuration for the transactions table.
// Used to display details about inventory transactions (receiving, releasing, etc.).
export const columnsTransactions = [
  //{ title: "Item", data: "itemName" }, // Name of the item involved in the transaction
  { title: "Variation", data: "variationName" }, // Specific variation of the item
  { title: "Transaction Date", data: "transactionDate" }, // Date of transaction
  { title: "Qty", data: "transactionQty" }, // Quantity involved in the transaction
  { title: "Unit Price", data: "unitValue" }, // Price per unit for the transaction
  { title: "Total Value", data: "totalTransactionValue" }, // Total value for the transaction
  //{ title: "Average Value", data: "averageValue" }, // Average value for the transaction
  // {
  //   title: "Code (UPC / PLU / AltID)",
  //   data: null,
  //   render: function (data, type, row) {
  //     if (row.upc && row.upc !== "") return row.upc;
  //     if (row.plu && row.plu !== "") return row.plu;
  //     if (row.otherCode && row.otherCode !== "") return row.otherCode;
  //     return "";
  //   }
  // },

  // { title: "Category", data: "category" }, // Item category
  // { title: "Donation ID", data: "donationID" }, // ID for donation tracking
];

// Table column configuration for the item details modal/table.
// Used to display key-value pairs for a single item's details.
export const columnsItemDetails = [
  { title: "Field", data: "key" },   // Field name (e.g., "Category", "Pack Size")
  { title: "Value", data: "value" }  // Field value (e.g., "Food", "6pk")
];
